import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { Loader2, MailX, MailCheck, AlertCircle } from 'lucide-react';
import Footer from '../components/Footer';
import { unsubscribe, resubscribe } from '../lib/api';

function Card({ icon: Icon, title, children, testid }) {
  return (
    <div data-testid={testid} className="max-w-[560px] mx-auto bg-white rounded-sm p-10 md:p-12 text-center shadow-[0_10px_50px_rgba(0,0,0,0.07)] border border-neutral-100">
      <div className="w-20 h-20 rounded-full bg-[#eef4f8] flex items-center justify-center mx-auto mb-6"><Icon size={36} className="text-[#4a9cd4]" /></div>
      <h1 className="font-serif-ah text-[32px] md:text-[38px] text-[#2f2f2f] mb-4 leading-tight">{title}</h1>
      {children}
    </div>
  );
}

export default function UnsubscribePage() {
  const [params] = useSearchParams();
  const token = params.get('t') || '';
  const [state, setState] = useState('loading');
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!token) { setState('invalid'); return; }
    unsubscribe(token).then((r) => { setEmail(r.email); setState('unsubscribed'); }).catch(() => setState('invalid'));
  }, [token]);

  const undo = async () => {
    setBusy(true);
    try { await resubscribe(token); setState('resubscribed'); } catch { setState('invalid'); }
    setBusy(false);
  };

  return (
    <>
      <section className="bg-[#f8f6f2] min-h-[78vh] pt-40 pb-20 px-6">
        {state === 'loading' && <div className="flex justify-center pt-20"><Loader2 size={34} className="animate-spin text-[#4a9cd4]" /></div>}
        {state === 'unsubscribed' && (
          <Card icon={MailX} title="You've been unsubscribed" testid="unsubscribe-success">
            <p className="font-sans-ah text-[15px] text-[#666] font-300 mb-8"><strong>{email}</strong> will no longer receive Chamber newsletters. We're sorry to see you go.</p>
            <button onClick={undo} disabled={busy} data-testid="resubscribe-btn" className="btn-ah-solid font-sans-ah text-[13px] px-8 py-3.5 rounded-sm inline-flex items-center gap-2 disabled:opacity-60">
              {busy && <Loader2 size={15} className="animate-spin" />} UNSUBSCRIBED BY MISTAKE? RESUBSCRIBE
            </button>
          </Card>
        )}
        {state === 'resubscribed' && (
          <Card icon={MailCheck} title="Welcome back!" testid="resubscribe-success">
            <p className="font-sans-ah text-[15px] text-[#666] font-300 mb-8"><strong>{email}</strong> is subscribed again to Chamber news and events.</p>
            <Link to="/" className="btn-ah-solid font-sans-ah text-[13px] px-8 py-3.5 rounded-sm inline-block">VISIT THE CHAMBER</Link>
          </Card>
        )}
        {state === 'invalid' && (
          <Card icon={AlertCircle} title="Link not recognised" testid="unsubscribe-invalid">
            <p className="font-sans-ah text-[15px] text-[#666] font-300 mb-8">This unsubscribe link is invalid or has expired. Reply to any Chamber email or contact us and we'll remove you right away.</p>
            <Link to="/contact" className="btn-ah-solid font-sans-ah text-[13px] px-8 py-3.5 rounded-sm inline-block">CONTACT US</Link>
          </Card>
        )}
      </section>
      <Footer />
    </>
  );
}
